import styled from 'styled-components';

export const BillingSurface = styled.div`
  --bill-bg: #ffffff;
  --bill-soft: #f3f4f6;
  --bill-text: #30343b;
  --bill-muted: #6b727d;
  --bill-line: #dce0e5;
  --bill-accent: #4a505b;
  --bill-tint: #eceef1;
  --bill-alert: #a1432f;
  --bill-alert-bg: #fff1e9;
  color: var(--bill-text);
  [data-auth-theme="night"] & {
    --bill-bg: #2b2e33;
    --bill-soft: #32353b;
    --bill-text: #e7e9ee;
    --bill-muted: #b4bac4;
    --bill-line: #454a53;
    --bill-accent: #d3d8e0;
    --bill-tint: #363b43;
    --bill-alert: #ffb69f;
    --bill-alert-bg: #432e28;
  }
  * { box-sizing: border-box; }
  h2, h3, h4, p { margin-top: 0; }
  h2 { font-size: 1.3rem; font-weight: 700; }
  h3 { font-size: 1.1rem; font-weight: 700; }
  p { line-height: 1.7; }
  button, input, select { font: inherit; }
  button { cursor: pointer; }
  button:disabled { opacity: .48; cursor: not-allowed; }
  :is(button, input, select):focus-visible { outline: 3px solid #8d9bb1; outline-offset: 3px; }
  input, select {
    width: 100%; min-width: 0; padding: 10px 12px;
    background: var(--bill-bg); color: var(--bill-text);
    border: 1px solid var(--bill-line); border-radius: 9px;
  }
  input[type="number"] { font-variant-numeric: tabular-nums; }
  label { display: grid; gap: 7px; font-size: .85rem; font-weight: 600; }
  .bill-muted { color: var(--bill-muted); font-size: .88rem; }
  .bill-card { padding: 24px; border: 1px solid var(--bill-line); border-radius: 18px; background: var(--bill-bg); margin-bottom: 20px; }
  .bill-heading { display: flex; justify-content: space-between; align-items: center; gap: 16px; margin-bottom: 18px; flex-wrap: wrap; }
  .bill-heading p { margin-bottom: 0; }
  .bill-button {
    display: inline-flex; align-items: center; justify-content: center; gap: 7px;
    padding: 10px 16px; border-radius: 10px; border: 1px solid var(--bill-line);
    color: var(--bill-text); background: var(--bill-bg); font-size: .9rem; font-weight: 600; white-space: nowrap;
  }
  .bill-button.primary { color: #fff; background: #4a505b; border-color: #4a505b; }
  .bill-button.danger { color: var(--bill-alert); }
  .bill-stats { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 14px; margin-bottom: 14px; }
  .bill-stat { padding: 22px; border: 1px solid var(--bill-line); border-radius: 15px; background: var(--bill-bg); }
  .bill-stat span { display: block; color: var(--bill-muted); font-size: .85rem; }
  .bill-stat strong { display: block; font-size: clamp(1.3rem, 2.5vw, 1.9rem); font-weight: 650; margin: 12px 0 5px; font-variant-numeric: tabular-nums; overflow-wrap: anywhere; }
  .bill-stat:last-child { background: var(--bill-tint); }
  .bill-empty { padding: 38px 12px; text-align: center; border: 1px dashed var(--bill-line); border-radius: 12px; color: var(--bill-muted); }
  .bill-empty strong { display: block; color: var(--bill-text); margin-bottom: 8px; }
  .bill-notice { padding: 13px 16px; border-radius: 10px; background: var(--bill-tint); line-height: 1.7; margin-bottom: 16px; font-size: .9rem; }
  .bill-notice.error { color: var(--bill-alert); background: var(--bill-alert-bg); }
  .bill-savebar { display: flex; flex-wrap: wrap; justify-content: space-between; align-items: center; gap: 15px; border: 1px solid var(--bill-line); padding: 18px 22px; border-radius: 14px; background: var(--bill-soft); margin-bottom: 28px; }
  .bill-savebar p { margin: 0; }
  .bill-actions { display: flex; gap: 10px; flex-wrap: wrap; }
  .bill-table-wrap { overflow-x: auto; }
  .bill-table { width: 100%; border-collapse: collapse; font-size: .9rem; }
  .bill-table th { color: var(--bill-muted); font-size: .78rem; font-weight: 600; text-align: left; padding: 12px 10px; background: var(--bill-soft); }
  .bill-table td { padding: 13px 10px; border-bottom: 1px solid var(--bill-line); vertical-align: top; }
  .bill-table tr:last-child td { border-bottom: none; }
  .bill-table input { padding: 9px 8px; }
  .bill-table .bill-name { min-width: 130px; }
  .bill-table .bill-number { min-width: 100px; }
  .bill-table .bill-date { min-width: 190px; }
  .bill-table .bill-notes { min-width: 150px; }
  .bill-table .bill-amount { text-align: right; white-space: nowrap; font-variant-numeric: tabular-nums; font-weight: 600; }
  .bill-badge { font-size: .75rem; padding: 4px 8px; border-radius: 6px; color: var(--bill-accent); background: var(--bill-tint); white-space: nowrap; }
  .bill-filters { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 16px; margin-bottom: 16px; }
  .bill-filters .bill-search { grid-column: span 2; }
  .bill-result-summary { display: flex; flex-wrap: wrap; gap: 10px 22px; padding: 14px 0; font-size: .87rem; border-top: 1px solid var(--bill-line); }
  .bill-result-summary strong { color: var(--bill-accent); }
  .bill-undo { display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 12px; }
  @media (max-width: 760px) {
    .bill-card { padding: 18px; }
    .bill-stats { gap: 8px; }
    .bill-stat { padding: 14px 10px; }
    .bill-stat span { font-size: .75rem; }
    .bill-filters { grid-template-columns: repeat(2, minmax(0, 1fr)); }
    .bill-table.editable thead { display: none; }
    .bill-table.editable, .bill-table.editable tbody { display: block; }
    .bill-table.editable tr { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; border: 1px solid var(--bill-line); border-radius: 12px; padding: 16px; margin-bottom: 12px; }
    .bill-table.editable td { display: block; padding: 0; border: 0; min-width: 0; }
    .bill-table.editable td::before { content: attr(data-label); display: block; font-size: .78rem; color: var(--bill-muted); margin-bottom: 6px; }
    .bill-table.editable .bill-name, .bill-table.editable .bill-date, .bill-table.editable .bill-notes { grid-column: span 2; }
    .bill-table.editable .bill-amount { text-align: left; }
    .bill-table.editable .bill-remove { align-self: end; text-align: right; }
    .bill-table.editable .bill-remove::before { display: none; }
    .bill-savebar { padding: 16px; }
  }
  @media (max-width: 420px) {
    .bill-stats { grid-template-columns: 1fr; }
    .bill-stat { display: flex; align-items: center; justify-content: space-between; gap: 10px; flex-wrap: wrap; }
    .bill-stat strong { margin: 0; font-size: 1.35rem; }
    .bill-stat small { width: 100%; }
  }
`;
